// extracted by mini-css-extract-plugin
export var cancelButton = "_ls-5";
export var content = "_ls-3";
export var createButton = "_ls-6";
export var drawerContainer = "_ls-0";
export var footer = "_ls-2";
export var header = "_ls-1";
export var orderFormColumn = "_ls-4";